import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Chip,
  MenuItem
} from "@mui/material";

import api from "../../api/api";

export default function Invoices() {

  const [invoices, setInvoices] = useState([]);

  const [filters, setFilters] = useState({
    client: "",
    status: "",
    date: ""
  });

  useEffect(() => {
    loadInvoices();
  }, []);

  // =====================================
  // LOAD INVOICES
  // =====================================

  const loadInvoices = async () => {

    try {

      const res = await api.get("/billing/invoices");

      setInvoices(res.data || []);

    } catch (err) {

      console.error("Invoice load error", err);

    }

  };

  // =====================================
  // HANDLE FILTER CHANGE
  // =====================================

  const handleFilterChange = (e) => {

    setFilters({
      ...filters,
      [e.target.name]: e.target.value
    });

  };

  // =====================================
  // FILTER LOGIC
  // =====================================

  const filteredInvoices = invoices.filter((i) => {

    return (

      (filters.client === "" ||
        (i.client || "").toLowerCase().includes(filters.client.toLowerCase())) &&

      (filters.status === "" || i.status === filters.status) &&

      (filters.date === "" ||
        (i.invoice_date || "").includes(filters.date))

    );

  });

  // =====================================
  // GENERATE FINAL INVOICE FROM DRAFT
  // =====================================
	
  const generateFromDraft = async (id) => {

    try {

      const url = `/billing/generate-from-draft/${id}`;
	  await api.post(url);

      alert("Invoice generated successfully");

      loadInvoices();

    } catch (err) {

      console.error("Generate from draft error", err);

    }

  };

  // =====================================
  // UPDATE INVOICE STATUS
  // =====================================

  const updateStatus = async (id, action) => {

    try {

      await api.put(`/billing/invoices/${id}/${action}`);

      loadInvoices();

    } catch (err) {

      console.error("Invoice status update error", err);

    }

  };

  // =====================================
  // OPEN PDF PREVIEW
  // Uses the SAME endpoint as Project Billing
  // =====================================

  const downloadPDF = (id) => {

    try {

      const backendURL = `http://localhost:5000/api/billing/invoice-preview/${id}`;

      window.open(backendURL, "_blank");

    } catch (err) {

      console.error("PDF preview error", err);

    }

  };

  // =====================================
  // STATUS CHIP UI
  // =====================================

  const getStatusChip = (status) => {

    if (status === "DRAFT")
      return <Chip label="Draft" />;

    if (status === "APPROVED")
      return <Chip label="Approved" color="info" />;

    if (status === "SENT")
      return <Chip label="Sent" color="warning" />;

    if (status === "PARTIALLY_PAID")
      return <Chip label="Partially Paid" color="secondary" />;

    if (status === "PAID")
      return <Chip label="Paid" color="success" />;

    if (status === "CANCELLED")
      return <Chip label="Cancelled" color="error" />;

    return <Chip label={status || "Unknown"} />;

  };

  return (

    <Box p={4}>

      <Typography variant="h5" mb={3}>
        Invoices
      </Typography>

      {/* ===================================== */}
      {/* FILTER SECTION */}
      {/* ===================================== */}

      <Card sx={{ mb: 3 }}>

        <CardContent>

          <Grid container spacing={2}>

            <Grid item xs={12} md={4}>
              <TextField
                label="Client"
                name="client"
                fullWidth
                value={filters.client}
                onChange={handleFilterChange}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                select
                label="Status"
                name="status"
                fullWidth
                value={filters.status}
                onChange={handleFilterChange}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="DRAFT">Draft</MenuItem>
                <MenuItem value="APPROVED">Approved</MenuItem>
                <MenuItem value="SENT">Sent</MenuItem>
                <MenuItem value="PAID">Paid</MenuItem>
                <MenuItem value="CANCELLED">Cancelled</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                type="date"
                label="Invoice Date"
                name="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={filters.date}
                onChange={handleFilterChange}
              />
            </Grid>

          </Grid>

        </CardContent>

      </Card>

      {/* ===================================== */}
      {/* INVOICE TABLE */}
      {/* ===================================== */}

      <Card>

        <CardContent>

          <Table>

            <TableHead>

              <TableRow>

                <TableCell>Invoice #</TableCell>
                <TableCell>Client</TableCell>
                <TableCell>Invoice Date</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>

              </TableRow>

            </TableHead>

            <TableBody>

              {filteredInvoices.map((i) => (

                <TableRow key={i.id}>

                  {/* Draft invoices show "Draft" */}

                  <TableCell>
                    {i.invoice_number ? i.invoice_number : "Draft"}
                  </TableCell>

                  <TableCell>{i.client || "N/A"}</TableCell>

                  <TableCell>{i.invoice_date || "-"}</TableCell>

                  <TableCell>₹ {i.amount || 0}</TableCell>

                  <TableCell>
                    {getStatusChip(i.status)}
                  </TableCell>

                  <TableCell>

                    {i.status === "DRAFT" && (
                      <Button
                        size="small"
                        color="success"
                        onClick={() => generateFromDraft(i.id)}
                      >
                        Generate
                      </Button>
                    )}

                    {i.status === "APPROVED" && (
                      <Button
                        size="small"
                        onClick={() => updateStatus(i.id, "send")}
                      >
                        Send
                      </Button>
                    )}

                    <Button
                      size="small"
                      onClick={() => downloadPDF(i.id)}
                    >
                      PDF
                    </Button>

                    {(i.status === "DRAFT" || i.status === "APPROVED") && (
                      <Button
                        size="small"
                        color="error"
                        onClick={() => updateStatus(i.id, "cancel")}
                      >
                        Cancel
                      </Button>
                    )}

                  </TableCell>

                </TableRow>

              ))}

            </TableBody>

          </Table>

        </CardContent>

      </Card>

    </Box>

  );

}